export default "__VITE_ASSET__DJYNFNNd__"